import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ResearchPageNew from './pages/ResearchPageNew';
import HighlandGlobalPage from './pages/HighlandGlobalPage';
import ProgrammesPage from './pages/ProgrammesPage';
import LibraryPage from './pages/LibraryPage';
import PeoplePage from './pages/PeoplePage';
import CommunityPage from './pages/CommunityPage';
import EventsPage from './pages/EventsPage';
import ContactPage from './pages/ContactPage';
import FellowsPage from './pages/FellowsPage';
import EkologosPage from './pages/EkologosPage';
import MyClimatePage from './pages/MyClimatePage';
import PluriMedPage from './pages/PluriMedPage';
import EarthkeepersPage from './pages/EarthkeepersPage';
import WarResiduesPage from './pages/WarResiduesPage';
import StudyWithUsPage from './pages/StudyWithUsPage';
import SummerSchoolPage from './pages/SummerSchoolPage';
import HighlandLocalPage from './pages/HighlandLocalPage';
import TastingTomorrowPage from './pages/TastingTomorrowPage';
import HagafPage from './pages/HagafPage';
import UrbaltourPage from './pages/UrbaltourPage';
import BowerLecturesPage from './pages/BowerLecturesPage';
import FieldworkPage from './pages/FieldworkPage';
import LibraryLandingPage from './pages/LibraryLandingPage.tsx';
import LibraryCataloguePage from './pages/LibraryCataloguePage.tsx';
import LibraryBookDetailPage from './pages/LibraryBookDetailPage.tsx';
import SearchResultsPage from './pages/SearchResultsPage';
import PeopleIndexPage from './pages/PeopleIndexPage';
import PersonProfilePage from './pages/PersonProfilePage';
import VegrHeader from './components/VegrHeader';
import VegrFooter from './components/VegrFooter';
import VegrHomePageNew from './pages/VegrHomePageNew';
import VegrReportPage from './pages/VegrReportPage';
import VegrAboutPage from './pages/VegrAboutPage';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Vegr App Routes */}
          <Route path="/vegr/*" element={
            <>
              <VegrHeader />
              <main className="pt-20">
                <Routes>
                  <Route path="/" element={<VegrHomePageNew />} />
                  <Route path="/report" element={<VegrReportPage />} />
                  <Route path="/about" element={<VegrAboutPage />} />
                  <Route path="/map" element={<VegrHomePageNew />} />
                  <Route path="/reports" element={<VegrHomePageNew />} />
                </Routes>
              </main>
              <VegrFooter />
            </>
          } />

          {/* Highland Institute Routes */}
          <Route path="/*" element={
            <>
              <Header />
              <main className="pt-36">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/people" element={<PeoplePage />} />
                  <Route path="/research" element={<ResearchPageNew />} />
                  <Route path="/research/ekologos" element={<EkologosPage />} />
                  <Route path="/research/myclimate" element={<MyClimatePage />} />
                  <Route path="/research/mycclimate" element={<MyClimatePage />} />
                  <Route path="/research/plurimed" element={<PluriMedPage />} />
                  <Route path="/research/earthkeepers" element={<EarthkeepersPage />} />
                  <Route path="/research/war-residues" element={<WarResiduesPage />} />
                  <Route path="/research/tasting-tomorrow" element={<TastingTomorrowPage />} />
                  <Route path="/research/hagaf" element={<HagafPage />} />
                  <Route path="/urbaltour" element={<UrbaltourPage />} />
                  <Route path="/bower-lectures" element={<BowerLecturesPage />} />
                  <Route path="/fieldwork" element={<FieldworkPage />} />
                  <Route path="/programmes" element={<ProgrammesPage />} />
                  <Route path="/search" element={<SearchResultsPage />} />
                  <Route path="/people" element={<PeopleIndexPage />} />
                  <Route path="/people/:id" element={<PersonProfilePage />} />
                  <Route path="/library" element={<LibraryLandingPage />} />
                  <Route path="/library/catalogue" element={<LibraryCataloguePage />} />
                  <Route path="/library/catalogue/:id" element={<LibraryBookDetailPage />} />
                  <Route path="/library/archives" element={<LibraryLandingPage />} />
                  <Route path="/library/oral-history" element={<LibraryLandingPage />} />
                  <Route path="/library/theses" element={<LibraryLandingPage />} />
                  <Route path="/library/guides" element={<LibraryLandingPage />} />
                  <Route path="/highland-global" element={<HighlandGlobalPage />} />
                  <Route path="/highland-local" element={<HighlandLocalPage />} />
                  <Route path="/study-with-us" element={<StudyWithUsPage />} />
                  <Route path="/summer-school" element={<SummerSchoolPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/community" element={<CommunityPage />} />
                  <Route path="/fellows" element={<FellowsPage />} />
                  <Route path="/publications" element={<LibraryPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/staff" element={<PeoplePage />} />
                  <Route path="/students" element={<HomePage />} />
                  <Route path="/alumni" element={<HomePage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;